import { Module } from "vuex";
import { RootState } from "../types";
import { InspectorsState } from "./types";

import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { Inspector } from '@/models';

// Default state
export const state: InspectorsState = {
	current: new Inspector(),
	list: [],
	month: undefined,
	search: undefined,
	updates: [],
	currentPage: 1,
  	pageLimit: 20,	
}

// User namespaced Vuex modules
const namespaced: boolean = true;

// Module export
const properties: Module<InspectorsState, RootState> = {
	state,
	getters,
	mutations,
	actions,
	namespaced,
}

export default properties;